export default "__VITE_ASSET__Dpo7QUov__"